import { useLocation } from "@reach/router";
import React, { useContext } from "react";
import Context from "../../context/Context";
import useAuthModal from "../../hooks/useAuthModal";
import { LoginButton } from "../buttons";
import { AuthLink } from "../links";
import VenueInfo from "../venue";

const NewHero = () => {
  const { opened, openModal, user, signOut } = useAuthModal();
  const data = useContext(Context);
  const { socialShare } = data;
  const { pathname } = useLocation();
  const virtual = pathname.includes("virtual");

  return (
    <div className="hero" id="top">
      <div className="hero-container">
        <div className="left">
          <h2>
            <img
              src="https://sng-client-assets.s3.amazonaws.com/fedscoop/upgather/googledefensesummit/SNG-Wordmark-Red.png"
              alt="Scoop News Group"
              width={331}
            />{" "}
            <span>Presents</span>
          </h2>
          <h1>
            Google Public Sector Forum
            <br />
            <span>The Intersection of AI and Security</span>
          </h1>
          <br />
          <AuthLink className="page login" to={"/virtual/live"}>
            On Demand
          </AuthLink>
          <div className="underwritten-container">
            <p>
              Underwritten by{"   "}
              <img
                src="https://sng-client-assets.s3.amazonaws.com/fedscoop/upgather/googledefensesummit/home/GoogleforGov.svg"
                alt="Google Sponsor Image"
              />
            </p>
          </div>
        </div>
        <img
          src="https://sng-client-assets.s3.amazonaws.com/fedscoop/upgather/googledefensesummit/login/Capital-Artwork-SNG-cropped.svg"
          alt="Capitol Image"
          className="right"
        />
      </div>
      <VenueInfo />
    </div>
  );
};

export default NewHero;
